module.exports = __webpack_public_path__ + "img/文档.669d6f31.png";